import {LayerTypeList} from "platformed-client/lists";
import {LayerType, Question, ResponseLayer} from "platformed-client/types";
import {Type} from "../utils/typing";
import {useAccountLocalState} from "./accountLocalState";

const LayerTypeSchema = Type.Enum([...LayerTypeList]);

export function useLayerType() {
  return useAccountLocalState(`questionLayerType`, LayerTypeSchema, "External");
}

const LAYER_TYPES = ["External", "Internal", "AI"];

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
export type OptionalResponseLayer = PartialBy<ResponseLayer, "activity_stream">;

export function getResponseLayer(
  responseLayers: Question["response_layers"],
  layerType: LayerType,
): OptionalResponseLayer {
  let responseLayer = responseLayers[layerType];
  if (responseLayer) {
    return responseLayer;
  }
  for (let idx = LAYER_TYPES.indexOf(layerType) - 1; idx >= 0; --idx) {
    responseLayer = responseLayers[LAYER_TYPES[idx]];
    if (responseLayer) {
      return {...responseLayer, owner: undefined, documentation_count: 0, activity_stream: undefined};
    }
  }
  throw new Error("Unreachable");
}

export function getExternalLayer(question: Question): ResponseLayer {
  return question.response_layers["External"]!;
}
